'use strict';

import angular from 'angular';
import Main from './main.controller';

export default angular.module('bfastCaptureManagerApp.application.main', [])
  .controller('AppMainController', Main)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/main/index.js